import { render, staticRenderFns } from "./LegalFollowUpAcknowledgeComp.vue?vue&type=template&id=b294f398&scoped=true"
import script from "./LegalFollowUpAcknowledgeComp.vue?vue&type=script&lang=js"
export * from "./LegalFollowUpAcknowledgeComp.vue?vue&type=script&lang=js"
import style0 from "./LegalFollowUpAcknowledgeComp.vue?vue&type=style&index=0&id=b294f398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b294f398",
  null
  
)

export default component.exports